var exports = {
  "n": "xb99ab02a--3fafdf--link",
  "l": "xb99ab02a--3fafdf--link-name",
};

module.exports = exports;
